
  var _styles = {
  "expire-time-display": {
    "width": "100%",
    "height": "0.37333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem",
    "marginBottom": "0.26667rem"
  },
  "expire-time-text": {
    "height": "0.37333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem"
  }
};



  module.exports = _styles;
  